// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__3GA2m","resendInfoText":"OnGoingPaymentBox_resendInfoText__y6BJf"};